<template>
  <div class="widget">
    <div class="widget-label">
      <div class="label">
        <p>Innovations &amp; Efficiencies</p>
      </div>
      <b-button
        v-if="addNewText"
        @click="addNew(addNewText)"
        variant="primary"
        class="right-align"
      >
        {{ addNewText }}
      </b-button>
    </div>
    <b-tabs fluid>
      <b-tab @click="setCurrentTab(0)">
        <template v-slot:title>
          <b-icon icon="list-check"></b-icon> New Innovations
          <span v-if="newInnovations.length > 0" class="notice">
            {{ newInnovations.length }}
          </span>
        </template>

        <div class="widget-content">
          <ProjectMetricEntries
            :projectMetrics="newInnovations.slice(0, length)"
            :fields="fields"
            @refresh="loadInnovations"
          ></ProjectMetricEntries>
          <div class="btn-wrapper">
            <b-button
              v-if="newInnovations.length > length"
              @click="$refs['all-innovations'].show()"
              variant="tertiary"
              class="view"
            >
              View All
            </b-button>
            <b-modal
              ref="all-innovations"
              title="Innovations"
              ok-title="Close"
              ok-only
            >
              <ProjectMetricEntries
                :projectMetrics="newInnovations"
                :fields="fields"
                @refresh="loadInnovations"
              ></ProjectMetricEntries>
            </b-modal>
          </div>
        </div>
        <!-- <div class="no-card widget-content">
          <ProjectMetricList
            :projectMetrics="newInnovations.slice(0, length)"
            title="New Innovations"
            addTitle="New Innovation"
            noneText="No new innovations"
            :showLimit="0"
            :allowAdd="true"
            :addTypes="['Innovation']"
            :possibleAssignees="projectUsers"
            :projectId="projectId"
            :dataTemplate="dataTemplate"
            :presetTags="projectTags"
            :meetingId="meetingId"
            @update="loadInnovations"
          />
        </div> -->
      </b-tab>
      <b-tab @click="setCurrentTab(1)">
        <template v-slot:title>
          <b-icon icon="list-check"></b-icon> New Efficiencies
          <span v-if="newEfficiencies.length > 0" class="notice">
            {{ newEfficiencies.length }}
          </span>
        </template>

        <div class="widget-content">
          <ProjectMetricEntries
            :projectMetrics="newEfficiencies.slice(0, length)"
            :fields="fields"
            @refresh="loadEfficiencies"
          ></ProjectMetricEntries>
          <div class="btn-wrapper">
            <b-button
              v-if="newEfficiencies.length > length"
              @click="$refs['all-efficiencies'].show()"
              variant="tertiary"
              class="view"
            >
              View All
            </b-button>
            <b-modal
              ref="all-efficiencies"
              title="Innovations"
              ok-title="Close"
              ok-only
            >
              <ProjectMetricEntries
                :projectMetrics="newEfficiencies"
                :fields="fields"
                @refresh="loadEfficiencies"
              ></ProjectMetricEntries>
            </b-modal>
          </div>
        </div>
        <!-- <div class="no-card widget-content">
          <ProjectMetricList
            :projectMetrics="newEfficiencies"
            title="New Efficiencies"
            addTitle="New Efficiency"
            noneText="No new efficiencies"
            :showLimit="0"
            :allowAdd="true"
            :addTypes="['Efficiency']"
            :possibleAssignees="projectUsers"
            :projectId="projectId"
            :dataTemplate="dataTemplate"
            :presetTags="projectTags"
            :meetingId="meetingId"
            @update="loadEfficiencies"
          />
        </div> -->
      </b-tab>
    </b-tabs>

    <EditProjectMetricModal
      ref="add-innovation-modal"
      :projectId="projectId"
      title="New Innovation"
      :mode="'Add'"
      :possibleAssignees="projectUsers"
      :addTypes="['Innovation']"
      :presetTags="projectTags"
      @submit="submitInnovation"
      :dataTemplate="dataTemplate"
    />

    <EditProjectMetricModal
      ref="add-efficiency-modal"
      :projectId="projectId"
      title="New Efficiency"
      :mode="'Add'"
      :possibleAssignees="projectUsers"
      :addTypes="['Efficiency']"
      :presetTags="projectTags"
      @submit="submitEfficiency"
      :dataTemplate="dataTemplate"
    />
  </div>
</template>

<script>
import ProjectMetricList from "@/components/project/ProjectMetricList.vue";
import ProjectMetricEntries from "@/components/list-entries/ProjectMetricEntries.vue";
import EditProjectMetricModal from "@/components/modals/EditProjectMetricModal.vue";

export default {
  name: "InnovationEfficiencySection",
  components: {
    ProjectMetricList,
    ProjectMetricEntries,
    EditProjectMetricModal,
  },
  props: {
    projectMetrics: {
      type: Array,
      required: true,
    },
    projectUsers: {
      type: Array,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
    projectTags: {
      type: Array,
      required: true,
    },
    meetingId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentTab: 0,
      length: 6,
      dataTemplate: {
        overrides: [
          {
            actions: ["Add"],
            key: "status",
            value: "Closed",
          },
        ],
      },
      fields: [
        { key: "name", label: "Item" },
        { key: "champion", label: "Champion(s)" },
        { key: "timeSaved", label: "Days Saved" },
        { key: "costSaved", label: "$ Saved" },
        { key: "kebab", label: "", thClass: "skinny-col" },
      ],
    };
  },
  methods: {
    setCurrentTab(x) {
      this.currentTab = x;
    },
    addNew() {
      switch (this.currentTab) {
        case 0:
          this.addInnovation();
          break;
        case 1:
          this.addEfficiency();
          break;
      }
    },
    addInnovation() {
      this.$refs["add-innovation-modal"].show();
    },
    addEfficiency() {
      this.$refs["add-efficiency-modal"].show();
    },
    loadInnovations() {
      this.$emit("update", "innovation");
    },
    loadEfficiencies() {
      this.$emit("update", "efficiency");
    },
    submitInnovation() {
      this.loadInnovations();
      this.closeAllModals();
    },
    submitEfficiency() {
      this.loadEfficiencies();
      this.closeAllModals();
    },
    closeAllModals() {
      this.$refs["add-innovation-modal"].cancel();
      this.$refs["add-efficiency-modal"].cancel();
    },
  },
  computed: {
    addNewText() {
      switch (this.currentTab) {
        case 0:
          return "Add New Innovation";
        case 1:
          return "Add New Efficiency";
      }
    },
    newInnovations() {
      return this.projectMetrics.filter((a) => a.type === "Innovation");
    },
    newEfficiencies() {
      return this.projectMetrics.filter((a) => a.type === "Efficiency");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>